// components/Footer/Footer.js
import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-logo">
            <h1>Zyve</h1>
            {/* <img src="./assets/logoblack.png" alt="Zyve" /> */}
            <p>© Zapstyle Fashion Pvt.Ltd</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3>Contact Us</h3>
              <ul>
                <li>
                  <a href="#">Help & Support</a>
                </li>
                <li>
                  <a href="#">Partner with us</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Available In</h3>
              <ul>
                <li>
                  <a href="#">Hyderabad</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Legal</h3>
              <ul>
                <li>
                  <a href="#">Terms & Conditions</a>
                </li>
                <li>
                  <a href="#">Privacy Policy</a>
                </li>
                <li>
                  <a href="#">Cookie Policy</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Social</h3>
              <ul>
                <li>
                  <a href="#">
                    <i className="fab fa-instagram"></i> Instagram
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="footer-bottom">
          <p>For better experience, download the Zyve app now</p>
          <div className="app-buttons">
            <a href="https://www.apple.com/in/app-store/" className="app-button">
              <img src="./assets/appstore.png" alt="Download on App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.fastyle.user&hl=en_IN" className="app-button">
              <img src="./assets/playstore.png" alt="Get it on Google Play" />
              </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;